export * from './SocialLinks';
export { default as SocialLinks } from './SocialLinks';
